export default __webpack_public_path__ + "static/family-and-you-logo-a817311be30633425ac5b7c8bfbc2339.png";